export default __webpack_public_path__ + "img/moon-cloud-snow.ec053fa.svg";